var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnCloseApiMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4701 4.47206C12.7305 4.21171 12.7305 3.7896 12.4701 3.52925C12.2098 3.2689 11.7876 3.2689 11.5273 3.52925L7.9987 7.05784L4.4701 3.52925C4.20975 3.2689 3.78764 3.2689 3.52729 3.52925C3.26694 3.7896 3.26694 4.21171 3.52729 4.47206L7.05589 8.00065L3.52729 11.5292C3.26694 11.7896 3.26694 12.2117 3.52729 12.4721C3.78764 12.7324 4.20975 12.7324 4.4701 12.4721L7.9987 8.94346L11.5273 12.4721C11.7876 12.7324 12.2098 12.7324 12.4701 12.4721C12.7305 12.2117 12.7305 11.7896 12.4701 11.5292L8.94151 8.00065L12.4701 4.47206Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCloseApiMenu);
export default __webpack_public_path__ + "static/media/btn-close-api-menu.5fa736cb.svg";
export { ForwardRef as ReactComponent };